import "./FxeQuizDialog.scss";
import {IModalService} from "angular-ui-bootstrap";
import {FxeQuizDialogController} from "./FxeQuizDialogController";

export class FxeQuizService {

    public static id = "fxeQuizService";

    /** @ngInject */
    public constructor(private $uibModal: IModalService) {
    }

    public async open(): Promise<void> {
        const instance = this.$uibModal.open({
            templateUrl: "app/quiz/fxe/service/FxeQuizDialog.html",
            backdrop: "static",
            size: "xl",
            windowClass: "fxe-quiz-dialog",
            controller: FxeQuizDialogController,
            controllerAs: "ctrl"
        });
        return instance.result;
    }
}
